export default "__VITE_ASSET__BPl3pijY__"